import React from "react";
import "./Button.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const STYLES = ["btn--primary", "btn--outline"];

const SIZES = ["btn--medium", "btn--large"];

export const Button = ({
  children,
  type,
  onClick,
  buttonStyle,
  buttonSize,
  pageURL
}) => {
  const checkButtonStyle = STYLES.includes(buttonStyle)
    ? buttonStyle
    : STYLES[0];

  const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

  const localPath = useLocation().pathname.replace(/\//g, "");

  const btnTitle = pageURL.replace(/\//g, "");

  return (
    <Link
      to={pageURL}
      className='btn-mobile'
      title={localPath ? `${localPath}-${btnTitle}-btn` : `home-${btnTitle}-btn`}
    >
      <button
        className={`btn ${checkButtonStyle} ${checkButtonSize}`}
        onClick={onClick}
        type={type}
      >
        {children}
      </button>
    </Link>
  );
};
